<div class="clr-row">
  <div class="clr-col">
    <div class="edit-control">
      <ngx-wig (paste)="pasted($event)"  class="full-editor" [disabled]="!editable" id="edit-control" *ngIf="model" name="edit-control" [(ngModel)]="model.html_text"
               [buttons]="'bold, italic, ul, ol, n, h1, h2, h3'"></ngx-wig>
    </div>
  </div>
</div>
